









import { Component, Vue } from 'vue-property-decorator';
import { getText } from '@/common/locales';
import Message from '@/common/components/Message.vue';

@Component({
    components: {
        Message,
    },
})
export default class PageNotFound extends Vue {
    public messageTitle = '404';
    public messageDescription = getText('components.page_not_found.page_not_exists');
}
